import React,{useState,useEffect} from 'react';
import { Form, Checkbox } from 'antd';
import FiltersDynamic from '../Components/FiltersDynamicComponent';

const TriggeringApprovalCriteria = ({
  availableFields,
  manualTriggering,
  setManualTriggering,
  triggeringFilterCriteria,
  setTriggeringFilterCriteria,
  setLogicForTriggering,
  logicForTriggering,
  setValueOperatorTriggering,
  valueOperatorTriggering
}) => {
  const lookupOptions = [];
    
  const handleManualChange = (e) => {
    const checked = e.target.checked;
    setManualTriggering(checked);
    if (checked) {
      // If manual is checked, clear filters
      setTriggeringFilterCriteria([{ 1: { field: '', value: '', displayValue: '' } }]);
    }
  };

  const handleCriteriaChange = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setManualTriggering(false);
    }
  };

  return (
    <>
      <Form.Item>
        <Checkbox checked={manualTriggering} onChange={handleManualChange}>
          Manual Triggering
        </Checkbox>
      </Form.Item>

      <Form.Item>
        <Checkbox
          checked={!manualTriggering}
          onChange={handleCriteriaChange}
        >
          Criteria-based Triggering
        </Checkbox>
      </Form.Item>
    <Form.Item name="triggeringCriteria" initialValue={triggeringFilterCriteria}>
        
      {!manualTriggering && (
        <FiltersDynamic
          fields={availableFields}
          logic={logicForTriggering}
          setLogic={setLogicForTriggering}
          filters={triggeringFilterCriteria}
          setFilters={setTriggeringFilterCriteria}
          setValueOperator={setValueOperatorTriggering}
          valueOperator={valueOperatorTriggering}
          fetchLookupRecordsForExistingFilters={() => {}}
          fetchLookupRecords={() => {}}
          lookupOptions={lookupOptions}
          heading="Triggering Criteria Filters"
        />
      )}
      </Form.Item>

    </>
  );
};

export default TriggeringApprovalCriteria;
